<template>
  <div>
    <div class='box'>
      <div
        v-if="schoolCode == '10013'"
        :class=" 'box-imgT box-img'"
      >
        <!-- <span>北邮微教学222</span> -->
        <img src="../../../../static/images/logo.png" alt=""> 
      </div> 
      <!-- userType == '0' ? 'box-imgS box-img' : 'box-imgT box-img' -->
      
    </div>
    <div
      class="box"
      :style="
        schoolCode == '10013'||schoolCode=='10541'||schoolCode=='12981'
          ? 'padding: 0 20px 49px'
          : 'padding: 16px 15px 54px'
      "
    > 
      <!-- <div class="common"
        v-for="(menu, index1) of menuList"
        :key="index1"
      >
        <van-grid 
          :column-num= 5
          v-if="index1 == 4"
        >
          <van-grid-item 
            class="common-item"
            v-for="(item, index2) of menu.child"
            :key="index2"
            @click="goMenu(item)"
          >
            <span
              v-if="item.icon && item.icon.class"
              :class="item.icon.class"
              style="color:#2B67E1"
            ></span>
            <span
              v-else
              class="iconfont iconshouye9"
              style="color:#FF8080"
            ></span>
            <span class="item-value">{{ `${item.name}  ` }}</span>
          </van-grid-item>
          <van-grid-item
            @click="gomenu(item)"
          >
            <span  class=iconfont
              style="color:#2B67E1"></span>
            <div class="item-value" @click="handleMore">更多</div>
          </van-grid-item>
        </van-grid>
      </div> -->
 
      <div class="common">
        <van-grid 
          :column-num= 5 
        >
          <van-grid-item 
            class="common-item"
            v-for="(item, index2) of commMenuList"
            :key="index2"
            @click="goMenu(item)"
          >
            <div
              class="abb"
            >
              <img
                v-if="item.imgUrl"
                :class="iconfont"
                :src="item.imgUrl"
                style="color:#2B67E1"
                alt=""
              />
              <img
                v-else 
                src="../../../../static/img/images_10013/24.png"
                class="iconfont"
                style="color:#2B67E1"
                alt=""
              />
            </div>
           
            <span class="item-value">{{ `${item.name}  ` }}</span>
          </van-grid-item>
          <van-grid-item
            @click="gomenu(item)"
          >
            <span  class=abb
              style="color:#2B67E1"
            >
              <img 
                src="../../../../static/img/images_10013/更多.png"
                class="iconfont"
                style="color:#2B67E1"
                alt=""
                @click="handleMore()"
              />
            </span>
            <div class="item-value" @click="handleMore()">更多</div>
          </van-grid-item>
        </van-grid>
      </div> 
      <!-- <div class='message'>
        <h2>待审核信息</h2>
        <div 
          class="message-item"item 
          v-for="item in "
        >
          <div>{{item.tip}}</div>
          <div>2021年暑假放假通知</div>
          <div>时间：2021-1-24 16:30</div>
          </div>
      </div> -->
      <newCheck_10013Vue/>
      <!-- <newMsg/> -->
    </div>
  </div>
</template>

<script>
import newMsg_10013 from "./newMsg_10013.vue"
import newMsg from "./newMsg.vue"

import { Api } from "@/utils/axios";

import Vue from "vue";
import { Collapse, CollapseItem } from "vant";
import { Grid, GridItem } from "vant";
import newCheck_10013Vue from './newCheck_10013.vue';

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
export default {
  components:{newCheck_10013Vue,newMsg},
  data() {
    return {
      show: false,
      message: "",
      heardName : "工具箱",
      menuNub:3,
      ms: 0,
      activeNames: [],
      menuList: [],
      commMenuList:[],
      itemList: [],
      userType: false,
      i_id: "",
      resetList: [],
      Identity:
        sessionStorage.getItem("Identity") ||
        JSON.parse(sessionStorage.getItem("userInfo")).userType,
      isNeedLogout: sessionStorage.getItem("isNeedLogout"),
      teacherList: [
        {
          name: "",
          path: "/sksjsqsh/index",
          url: "js_sh_sksjsq",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/sksjqrsh/index",
          url: "js_sh_sksjqr",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "劳动任务审核",
          path: "/workTaskPass/index",
          url: "js_ldrwsh",
		  imgUrl:"../../../../sjd/static/img/images_10013/16.png",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        },
        {
          name: "班级成绩查询",
          path: "/grade/search/search",
          url: "js_jsbjcj",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        },
        {
          name: "实训考勤",
          path: "/practiceKQ/index",
          url: "js_sxkq",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        },
        {
          name: "任务发布",
          path: "/taskAdd/index",
          url: "js_rwfb",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "学生名单查询",
          path: "/studentInfo/index",
          url: "js_xsmdcx",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "个人调课",
          path: "/personalTable/index",
          url: "js_grtk",
          icon: { class: "iconshouye14 iconfont", style: "color:#865FC1" }
        },
        {
          name: "教室借用申请",
          path: "/brrow10008/index",
          url: "js_jsjygl",
          icon: { class: "iconshouye1 iconfont", style: "color:#FFC327" }
        },
        {
          name: "教学学风评测",
          path: "/evaluateIndex",
          url: "js_jxpj_jxxfpc",
          icon: { class: "iconshouye1 iconfont", style: "color:#FFC327" }
        },
        {
          name: "免听审批",
          path: "/freePass/index",
          url: "js_sh_mt",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" },
          imgUrl:"../../../../sjd/static/img/images_10013/10.png"
        },

        {
          name: "成绩录入审核",
          path: "/pass/passIndex",
          icon: { class: "iconshouye14 iconfont", style: "color:#865FC1" }
        },
        {
          name: "教材使用评价",
          path: "/nod?title=教材使用评价",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "教学通知",
          path: "/jxzx/index?title=教学通知",
		  imgUrl:"../../../../sjd/static/img/images_10013/12.png",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "教学制度",
          path: "/jxzx/index?title=教学制度",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "教学新闻",
          path: "/jxzx/index?title=教学新闻",
		  imgUrl:"../../../../sjd/static/img/images_10013/10.png",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "我的课程",
          path: "/classTest/index?title=我的课程",
		  imgUrl:"../../../../sjd/static/img/images_10013/11.png",
          icon: { class: "iconfont iconshouye18", style: "color:#FFC327" }
        },
        {
          name: "课程作业",
          path: "/classTest/index?title=课程作业",
		  imgUrl:"../../../../sjd/static/img/images_10013/14.png",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "课程测验",
          path: "/classTest/index?title=课程测验",
		  imgUrl:"../../../../sjd/static/img/images_10013/5.png",
          icon: { class: "iconshouye9 iconfont", style: "color:#00C897" }
        },
        {
          name: "课程讨论",
          path: "/classTest/index?title=课程讨论",
		  imgUrl:"../../../../sjd/static/img/images_10013/10.png",
          icon: { class: "iconshouye21 iconfont", style: "color:#865FC1" }
        },
        {
          name: "学生缓考审核",
          path: "/teacher/bookIndex?id=6",
          url: "js_sh_xshk",
          icon: { class: "iconshouye9 iconfont", style: "color:#00C897" },
          imgUrl:"../../../../sjd/static/img/images_10013/12.png"
        },
        {
          name: "成绩查卷审核",
          path: "/teacher/bookIndex?id=8",
		  imgUrl:"../../../../sjd/static/img/images_10013/13.png",
          icon: { class: "iconshouye12 iconfont", style: "color:#FF8080" }
        },
        {
          name: "成绩录入审核",
          path: "/pass/passIndex?path=/new/Home",
          icon: { class: "iconshouye14 iconfont", style: "color:#865FC1" }
        },
        {
          name: "成绩修改审核",
          path: "/teacher/bookIndex?id=10",
		  imgUrl:"../../../../sjd/static/img/images_10013/14.png",
          icon: { class: "iconshouye21 iconfont", style: "color:#865FC1" }
        },
        {
          name: "调课审核",
          path: "/teacher/examine/adjustList?path=/new/Home",
          url: "js_sh_tk",
          icon: { class: "iconshouye10 iconfont", style: "color:#5E73FF" },
          imgUrl:"../../../../sjd/static/img/images_10013/16.png"
        },
        {
          name: "教室借用审核",
		  imgUrl:"../../../../sjd/static/img/images_10013/15.png",
          path: "/teacher/examine/borrowingList?path=/pass/index",
          icon: { class: "iconshouye25 iconfont", style: "color:#865FC1" }
        },
        {
          name: "监考查询",
          path: "/invigilate",
		  imgUrl:"../../../../sjd/static/img/images_10013/4.png",
          icon: { class: "iconfont iconshouye1", style: "color:#FFC327" }
        },
        {
          name: "学生成绩查询",
          path: "/studentCjxx",
          cicon: { class: "iconfont iconshouye1", style: "color:#FFC327" }
        },
        {
          name: "监考调代",
          path: "/teacher/examSearch",
          icon: { class: "iconfont iconshouye2", style: "color:#5E73FF" }
        },
        {
          name: "随堂考试",
          path: "/teacher/classList",
          icon: { class: "iconfont iconshouye3", style: "color:#865FC1" }
        },
        {
          name: "考场信息查询",
          path: "/teacher/examRoom",
          icon: { class: "iconfont iconshouye4", style: "color:#5E73FF" }
        },
        {
          name: "教学评价",
          path: "/evaluate",
          url: "js_xspjcx",
          icon: { class: "iconfont iconshouye4", style: "color:#5E73FF" }
        },
        {
          name: "评价结果查询",
          path: "/pjjgcx/pjjgcxQuery",
          url: "js_xspjcx",
          cicon: { class: "iconfont iconshouye1", style: "color:#FFC327" }
        },
        // {
        //   name: "教学评价",
        //   path: "/evaluate",
        //   url: "js_jxpj_jxpj",
        //   icon: { class: "iconfont iconshouye4", style: "color:#5E73FF" }
        // },
        {
          name: "评价结果查看",
          path: "/evaluationResults/index",
          url: "js_jxpjjg",
          icon: { class: "iconfont iconshouye8", style: "color:#865FC1" }
        },
        {
          name: "工作量查询",
          path: "/workNum/index",
          icon: { class: "iconfont iconshouye13", style: "color:#5E73FF" }
        },
        {
          name: "教学学风测评",
          path: "/teacher/learnHome",
          icon: { class: "iconfont iconshouye5", style: "color:#00C998" }
        },
        {
          name: "成绩修改",
          path: "/grade/update/index",
		  imgUrl:"../../../../sjd/static/img/images_10013/10.png",
          icon: { class: "iconfont iconshouye14", style: "color:#865FC1" }
        },
        {
          name: "成绩查询",
          path: "/grade/search/index",
          icon: { class: "iconfont iconchengjichaxun2", style: "color:#865FC1" }
        },
        {
          name: "培养方案总纲",
          path: "/train/indpyfazgIndexex",
		  imgUrl:"../../../../sjd/static/img/images_10013/7.png",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "专业培养方案",
          path: "/train/commonIndex",
		  imgUrl:"../../../../sjd/static/img/images_10013/7.png",
          icon: { class: "iconfont iconshouye7", style: "color:#865FC1" }
        },
        {
          name: "专业教学进程",
          path: "/train/teachingProcess",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "教学计划 ",
          path: "/train/teachingPlan",
          icon: { class: "iconfont iconshouye9", style: "color:#00C998" }
        },
        {
          name: "学生选题情况",
          path: "selected",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "调课申请",
          path: "/exchangeK/index",
          icon: { class: "iconfont iconshouye10", style: "color:#5E73FF" }
        },
        {
          name: "调课申请记录",
          path: "/exchangeK/historList",
          icon: { class: "iconfont iconshouye10", style: "color:#5E73FF" }
        },
        {
          name: "教材",
          path: "/teacher/textbook",
          url: "js_jc",
          icon: { class: "iconfont iconshouye11", style: "color:#FF8080" }
        },
        {
          name: "教室借用",
          path: "/bindex",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "教室借用记录",
          path: "/roomBorrow/historyList",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "考勤",
          path: "/teacher/attendance",
          icon: { class: "iconfont iconshouye23", style: "color:#865FC1" }
        },
        {
          name: "课程课表",
          path: "/surfaces",
          url: "js_kcb",
          icon: { class: "iconfont iconshouye17", style: "color:#00C998" }
        },
        {
          name: "我的课堂",
          path: "/teacher/create",
          icon: { class: "iconfont iconshouye19", style: "color:#FFC327" }
        },
        {
          name: "班级课表",
          // path: "/teacher/searchCondition?id=0",
          path: "/classTable/index",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "教师课表查询",
          path: "/teacher/searchCondition?id=1",
          url: "js_jiaoskcbcx",
          icon: { class: "iconfont iconshouye21", style: "color:#00C998" }
        },
        // {
        //   name: "课程课表",
        //   path: "/teacher/searchCondition?id=2",
        //   icon: { class: "iconfont iconshouye17", style: "color:#00C998" }
        // },
        // {
        //   name: "教室课表",
        //   path: "/teacher/searchCondition?id=3",
        //   icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        // },
        {
          name: "审核",
          path: "/pass/index",
          icon: { class: "iconfont iconshouye18", style: "color:#FFC327" }
        },
        {
          name: "毕业设计",
          path: "/design",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "空闲教室",
          path: "/restRooms/index",
		  imgUrl:"../../../../sjd/static/img/images_10013/1.png",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "今日空闲教室",
          path: "/restClassroom",
		  imgUrl:"../../../../sjd/static/img/images_10013/1.png",
          icon: { class: "iconfont iconshouye25", style: "color:#00C897" }
        },
        {
          name: "学生信息查询",
          path: "/informationService/index",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "",
          path: "/examSchedule",
          url: "js_ksapcx",
          icon: { class: "iconfont iconshouye25", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/ksapcx/index",
          url: "js_kw_ksapcx",
          icon: { class: "iconfont iconshouye25", style: "color:#5E73FF" }
        },
        {
          name: "学生评价统计",
          path: "/evaluateSum/index",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "通知",
          path: "/new/Msg",
          icon: { class: "iconfont iconshouye18", style: "color:#FF8080" }
        },
        {
          name: "顶岗实习",
          path: "/internshipTeacher/index",
          url: "js_dgsx",
          icon: { class: "iconfont iconshixiqiandao", style: "color:#FF8080" }
        },
        {
          name: "教学课程查询",
          path: "/teacher/jxkccx",
          code: "js_jxkcb",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "各类课表查询",
          path: "/teacher/surfaAll",
          code: "js_kb_all",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "课表查询(教师)",
          path: "/teacher/surCuseAll_Find?findType=0&singcont=1",
          code: "js_kb_all_skls",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "课表查询(班级)",
          path: "/teacher/surCuseAll_Find?findType=1&singcont=1",
          code: "js_kb_all_skbj",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8282" }
        },
        {
          name: "课表查询(课程)",
          path: "/teacher/surCuseAll_Find?findType=2&singcont=1",
          code: "js_kb_all_skkc",
          icon: { class: "iconfont iconshouye17", style: "color:#EE7BFF" }
        },
        {
          name: "课表查询(教室)",
          path: "/teacher/surCuseAll_Find?findType=3&singcont=1",
          code: "js_kb_all_skdd",
          icon: {
            class: "iconfont iconshouye17",
            style: "color:rgba(118,107,255,.7)"
          }
        },
        {
          name: "巡考查询",
          path: "/teacher/js_xkcx",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "成绩录入查询",
          path: "/teacher/scoreEntry",
          code: "js_cjllcx",
          icon: { class: "iconfont iconshouye18", style: "color:#EE7BFF" }
        },
        {
          name: "教师缓考审核",
          path: "/teacher/jshksh",
          url: "js_jshksh",
          icon: { class: "iconshouye9 iconfont", style: "color:#5E73FF" }
        },
        {
          name: "质量平台",
          path: "/zlpt",
          url: "js_zlpt",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "教师评学",
          path: "/jspx/jspxpc_find",
          url: "js_jspx",
          imgUrl:"../../../../sjd/static/img/images_10013/24.png",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        }
      ],
      // 学生端
      studentList: [
        {
          name: "",
          path: "/byxxhd/index",
          url: "xs_byxxhd",
          icon: { class: "iconfont iconshouye9", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/jhrxxcj/index",
          url: "xs_jhrxxcj",
          icon: { class: "iconfont iconshouye6", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/plhksq/index",
          url: "xs_plhk",
          icon: { class: "iconfont iconshouye9", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/fyApply/index",
          url: "xs_cjfhsq",
          icon: { class: "iconshouye2 iconfont", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/holiday/index",
          url: "xs_qj",
          icon: { class: "iconshouye2 iconfont", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/freeApply/index",
          url: "xs_mtsq",
		  imgUrl:"../../../../sjd/static/img/images_10013/13.png",
          icon: { class: "iconshouye25 iconfont", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/selectApply/index",
          url: "xs_cjsq",
		  imgUrl:"../../../../sjd/static/img/images_10013/12.png",
          icon: { class: "iconshouye15 iconfont", style: "color:#5E73FF" }
        },
        {
          name: "",
          path: "/sxChange/index",
          url: "xs_sxyd",
          icon: { class: "iconfont iconshouye1", style: "color:#5E73FF" }
        },
        {
          name: "",
          path: "/sxAlone/index",
          url: "xs_ddsxsq",
          icon: { class: "iconfont iconshouye9", style: "color:#00C998" }
        },
        {
          name: "",
          path: "/sxKq/index",
          url: "xs_sxkq",
          icon: { class: "iconfont iconshouye11", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/sxTask/index",
          url: "xs_sxrw",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/bk/xspj",
          url: "xspj_find",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "创新学分查看",
          path: "/cxxf/index",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "学业完成情况",
          path: "/xywcqk/index?title=学业完成情况",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "辅修学业完成情况",
          path: "/xywcqk/index?title=辅修学业完成情况",
          icon: { class: "iconshouye15 iconfont", style: "color:#5E73FF" }
        },
        {
          name: "学分完成情况",
          path: "/nod?title=学分完成情况",
		  imgUrl:"../../../../sjd/static/img/images_10013/16.png",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },

        {
          name: "处分信息",
          path: "/nod?title=处分信息",
          icon: { class: "iconfont iconshouye7", style: "color:#00C998" }
        },
        {
          name: "教材使用评价",
          path: "/nod?title=教材使用评价",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "教学通知",
          path: "/nod?title=教学通知",
		  imgUrl:"../../../../sjd/static/img/images_10013/12.png",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "教学制度",
          path: "/nod?title=教学制度",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "教学新闻",
          path: "/nod?title=教学新闻",
		  imgUrl:"../../../../sjd/static/img/images_10013/10.png",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "我的课程",
          path: "/classTest/index?title=我的课程",
		  imgUrl:"../../../../sjd/static/img/images_10013/11.png",
          icon: { class: "iconfont iconshouye18", style: "color:#FFC327" }
        },
        {
          name: "课程作业",
          path: "/classTest/index?title=课程作业",
		  imgUrl:"../../../../sjd/static/img/images_10013/14.png",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "课程测验",
          path: "/classTest/index?title=课程测验",
		  imgUrl:"../../../../sjd/static/img/images_10013/5.png",
          icon: { class: "iconshouye9 iconfont", style: "color:#00C897" }
        },
        {
          name: "课程讨论",
          path: "/classTest/index?title=课程讨论",
		  imgUrl:"../../../../sjd/static/img/images_10013/10.png",
          icon: { class: "iconshouye21 iconfont", style: "color:#865FC1" }
        },
        {
          name: "学业进度",
          path: "/student/studyStatu",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "学生教室借用",
          path: "/roomBrrow/index",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/bindex",
          url: "xs_jsjy_hnkjdx",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "学籍异动审核",
          path: "/teacher/bookIndex?id=4",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "学籍异动 ",
          path: "/student/change",
		  imgUrl:"../../../../sjd/static/img/images_10013/17.png",
          icon: { class: "iconfont iconshouye2", style: "color:#5E73FF" }
        },
        {
          name: "学籍预警",
          path: "/student/warning",
          icon: { class: "iconfont iconshouye15", style: "color:#FF8080" }
        },
        {
          name: "等级考试成绩 ",
          path: "/student/grades_score",
          url: "xs_cj_dj",
		  imgUrl:"../../../../sjd/static/img/images_10013/11.png",
          icon: { class: "iconfont iconshouye22", style: "color:#FFC327" }
        },
        {
          name: "学期考试成绩",
          path: "/student/semester_Score",
          url: "xs_cj_xq",
		  imgUrl:"../../../../sjd/static/img/images_10013/12.png",
          icon: { class: "iconfont iconshouye14", style: "color:#865FC1" }
        },
        {
          name: "成绩认定 ",
          path: "/student/score_Affirmation",
          icon: { class: "iconfont iconshouye21", style: "color:#865FC1" }
        },
        {
          name: "教学进度 ",
          path: "/student/syllabus",
          url: "xs_pyfa_jxjd",
		  imgUrl:"../../../../sjd/static/img/images_10013/7.png",
          icon: { class: "iconfont iconshouye8", style: "color:#00C897" }
        },
        {
          name: "执行计划 ",
          path: "/student/executePlan",
          icon: { class: "iconfont iconshouye7", style: "color:#865FC1" }
        },
        {
          name: "培养方案明细 ",
          path: "/train/index",
		  imgUrl:"../../../../sjd/static/img/images_10013/7.png",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "期末考试安排",
          path: "/student/exam",
		  imgUrl:"../../../../sjd/static/img/images_10013/4.png",
          icon: { class: "iconfont iconshouye16", style: "color:#FF8080" }
        },
        {
          name: "考试安排",
          path: "/student/exam",
		  imgUrl:"../../../../sjd/static/img/images_10013/4.png",
          icon: { class: "iconfont iconshouye16", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/student/evaluate_10013",
          url: "xs_xspj",
		  imgUrl:"../../../../sjd/static/img/images_10013/16.png",
          icon: { class: "iconfont iconshouye5", style: "color:#00C897" }
        },
        {
          name: "选课",
          path: "/student/pickClass",
          icon: { class: "iconfont iconxuanke", style: "color:#5E73FF" }
        },
        {
          name: "课程表",
          path: "/new/newTable_10013",
          url: "xs_kcb",
		  imgUrl:"../../../../sjd/static/img/images_10013/2.png",
          icon: { class: "iconfont iconshouye17", style: "color:#00C897" }
        },
        {
          name: "教材",
          path: "/student/textbook",
          url: "xs_jc",
          icon: { class: "iconfont iconshouye11", style: "color:#FF8080" }
        },
        {
          name: "顶岗实习",
          path: "/internship/index",
          url: "xs_dgsx",
          icon: { class: "iconfont iconshixiqiandao", style: "color:#FF8080" }
        },
        {
          name: "课堂签到",
          path: "/student/attendanceAdd",
          icon: { class: "iconfont iconketangqiandao", style: "color:#FFC327" }
        },
        {
          name: "等级考试报名",
          path: "/student/gradeExam",
          icon: { class: "iconfont iconshouye1", style: "color:#FFC327" }
        },
        {
          name: "空闲教室",
          path: "/restRooms/index",
		  imgUrl:"../../../../sjd/static/img/images_10013/1.png",
          icon: { class: "iconfont iconshouye25", style: "color:#865FC1" }
        },
        {
          name: "缓考",
          path: "/student/delayedExam",
		  imgUrl:"../../../../sjd/static/img/images_10013/10.png",
          url: "xs_hk",
          icon: { class: "iconfont iconshouye27", style: "color:#00C897" }
        },
        {
          name: "辅修报名",
          path: "/fxApply/index",
          icon: { class: "iconfont iconshouye27", style: "color:#00C897" }
        },
        {
          name: "学生过程评价",
          path: "/processEvaluation/index",
          icon: { class: "iconfont iconshouye27", style: "color:#00C897" }
        },
        {
          name: "学生评价",
          path: "/studentEvaluation/index",
          icon: { class: "iconfont iconshouye27", style: "color:#00C897" }
        },
        {
          name: "实习签到",
          path: "/sign/location",
          icon: { class: "iconfont iconshixiqiandao", style: "color:#5E73FF" }
        },
        {
          name: "班级课表",
          path: "/student/class-timetable-search",
          icon: { class: "iconfont iconbanjikebiao", style: "color:#5E73FF" }
        },
        {
          name: "毕业状态查询",
          path: "/student/SelectGraduationStatus-index",
          icon: {
            class: "iconfont iconbiyezhuangtaichaxun1",
            style: "color:#00C897"
          }
        },
        {
          name: "重修查询",
          path: "/student/searchRetest",
          icon: {
            class: "iconfont iconzhongxiubaoming",
            style: "color:#FF8080"
          }
        },
        {
          name: "重修报名",
          path: "/student/retouchList",
          icon: {
            class: "iconfont iconzhongxiubaoming",
            style: "color:#FF8080"
          }
        },
        {
          name: "补考报名",
          path: "/student/registRetest",
          icon: {
            class: "iconfont iconzhongxiubaoming",
            style: "color:#FF8080"
          }
        },
        {
          name: "补考查询",
          path: "/student/supplementExam",
          icon: { class: "iconfont iconbukaochaxun", style: "color:#00C897" }
        },
        {
          name: "今日空闲教室",
          path: "/restClassroom",
		  imgUrl:"../../../../sjd/static/img/images_10013/1.png",
          icon: { class: "iconfont iconshouye25", style: "color:#00C897" }
        },
        {
          name: "教学课堂反馈",
          path: "/teachAdvice/index",
          icon: {
            class: "iconfont iconketangjiaoxuefankui",
            style: "color:#00C897"
          }
        },
        {
          name: "通知",
          path: "/new/Msg",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "成绩排名规则查看",
          path: "/student/gradeRules",
          url: "xs_cjpmgzcx",
          icon: { class: "iconfont iconshouye8", style: "color:#00C897" }
        },
        {
          name: "顶岗实习",
          path: "/internship/index",
          url: "xs_dgsx",
          icon: { class: "iconfont iconshixiqiandao", style: "color:#FF8080" }
        },
        {
          icon: { class: "iconfont iconshouye19", style: "color:#FFC327" },
          name: "报到注册",
          path: "/student/registraTion",
          url: "xs_xjgl_bdzc"
        },
        {
          name: "各类课表查询",
          path: "/teacher/surfaAll",
          code: "js_kb_all",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "课表查询(教师)",
          path: "/teacher/surCuseAll_Find?findType=0&singcont=1",
          code: "xs_kb_all_skls",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "课表查询(班级)",
          path: "/teacher/surCuseAll_Find?findType=1&singcont=1",
          code: "xs_kb_all_skbj",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8282" }
        },
        {
          name: "课表查询(课程)",
          path: "/teacher/surCuseAll_Find?findType=2&singcont=1",
          code: "xs_kb_all_skkc",
          icon: { class: "iconfont iconshouye17", style: "color:#EE7BFF" }
        },
        {
          name: "课表查询(教室)",
          path: "/teacher/surCuseAll_Find?findType=3&singcont=1",
          code: "xs_kb_all_skdd",
          icon: {
            class: "iconfont iconshouye17",
            style: "color:rgba(118,107,255,.7)"
          }
        },
        {
          name: "学籍信息查看",
          path: "/student/xs_xjxxck",
          icon: { class: "iconfont iconshouye7", style: "color:#FF8080" }
        },
        {
          name: "免修",
          path: "/student/exemptExam",
          url: "xs_exemptExam",
          icon: { class: "iconfont iconshouye27", style: "color:#FFC327" }
        },
        {
          name: "实习打卡",
          path: "/punchTheClock/index",
          icon: { class: "iconfont iconshouye7", style: "color:#FFC327" }
        },
        {
          name: "质量平台",
          path: "/zlpt",
          url: "xs_zlpt",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "毕业设计",
          path: "/student/design",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
      ],
      pathList: [],
      iconList: [
        {
          name: "我的查询",
          icon: "search"
        },
        {
          name: "我的申请",
          icon: "underway-o"
        },
        {
          name: "我的审核",
          icon: "warning-o"
        },
        {
          name: "我的课程",
          icon: "shop-o"
        },
        {
          name: "教学资讯",
          icon: "hot-o"
        },
        {
          name: "云课堂",
          icon: "tv-o"
        }
      ],
      schoolCode: ""
    };
  },
  methods: {
    backApp() {
      this.$router.go(-2);
    },
    iteming() {
      if (this.schoolCode == "10541") {
        document.getElementById("itemimg").style.backgroundImage =
          "url(../../../assets/images/1650521253(1).png)";
      } else {
        document.getElementById("itemimg").style.backgroundImage =
          "url(../../../../static/image/headT.png)";
      }
    },
    // 个性化的菜单
    personMenu() {
      if (sessionStorage.getItem("schoolCode") === "10079") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "学业进度") {
            item.path = "/student/studyStatu1";
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") === "10548") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "教学评价") {
            item.path = "/evaluate1";
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") === "13104") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "重修报名") {
            item.path = "/cxApply/index";
          } else if (item.name.trim() == "补考报名") {
            item.path = "/bkApply/index";
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") === "10298") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "调课审核") {
            item.path = "/tksh/unpass";
          } 
        });
      }
    },
    goMenu(i_item) {
      if (this.schoolCode == "10013") {
        if (!!i_item.type && i_item.type == "a") {
          window.location.href = i_item.path;
        }
      }
      const arr = i_item.url.split("_");
      const val = arr[0] + "_" + arr[1];
      this.Change(val);

      this.$router.push({
        path: i_item.path
      });
      this.goCYGN(i_item);
    },
    handleMore() {
      // if (this.schoolCode == "10013") {
      //   if (!!i_item.type && i_item.type == "a") {
      //     window.location.href = i_item_path;
      //   }
      // }
      // const arr = i_item.url.split("_");
      // const val = arr[0] + "_" + arr[1];
      // this.Change(val);

      this.$router.push({
        path: '/commom/HomeMore_10013'
      });
      // this.goCYGN(i_item);
    },
    async goCYGN(item) {
      const res = await Api.saveCommonMenu({
        menu: item.url
      });
    },
    async Change(val) {
      const params = {
        xx0101id: this.schoolCode,
        type: this.Identity == "2" ? "0" : "",
        isqy: "",
        key: "qzkj"
      };
      const res = await Api.getHomeMenuApi(params);
      if (res.data.length > 0) {
        res.data.forEach(item => {
          if (item.url == val) {
            this.i_id = item.i_id;
          }
        });
      }
      this.getAuth();
    },
    async getAuth() {
      const params = {
        I_ID: this.i_id
      };
      const res = await Api.getSubMenu(params);
      this.resetList = res.data;
      if (res.data.length > 0) {
        this.resetList.forEach(item => {
          this.pathList.forEach(list => {
            if (item.url == list.url) {
              item.path = list.path;
            }
          });
        });
      }
    },
    async getMenu() {
      this.$forceUpdate();
      const params = {
        xx0101id: sessionStorage.getItem("schoolCode") || "10848",
        key: "qzkj",
        is_home: "1",
        type: this.Identity == "2" ? "0" : ""
      };

      // 判断是否存储了菜单
      if (sessionStorage.getItem("menuSave") == "1") {
        this.menuList = JSON.parse(sessionStorage.getItem("homeMenuList"));
        this.commMenuList =  JSON.parse(sessionStorage.getItem("homeCommonMenuList"));
      } else {
        // 第一次获取菜单
        const res = await Api.getHomeMenuApi(params);
        this.menuList = res.data;
        sessionStorage.setItem("homeMenuList", JSON.stringify(res.data));
        sessionStorage.setItem("menuSave", "1");

        // 第一次获取常用菜单
        const commonRes = await Api.getHomeCommonMenuApi_10013(params);
        this.commMenuList = commonRes.data;
        sessionStorage.setItem("homeCommonMenuList", JSON.stringify(commonRes.data)); 
      }
      if (!!this.menuList) {
        for (let i = 0; i < this.menuList.length; i++) {
          this.activeNames.push(this.menuList[i].i_id);
          let arr = [];
          this.menuList[i].child.forEach(item1 => {
            if (
              item1.url != "js_zsbm" &&
              item1.url != "js_bmqk" &&
              item1.url != "xs_bjkb"
            ) {
              arr.push(item1);
            }
          });
          this.menuList[i].child = arr;
        }
        this.menuList.forEach(item => {
          this.iconList.forEach(item3 => {
            if (item.name.trim() == item3.name.trim()) {
              item.icon = item3.icon;
            }
          });
          item.child.forEach(item1 => {
            this.pathList.forEach(item2 => {
              if (
                item1.name.trim() == item2.name.trim() ||
                (item2.url && item1.url.trim() == item2.url.trim())
              ) {
                item1.icon = item2.icon;
                item1.path = item2.path;
                item1.imgUrl = item2.imgUrl;
              }
            });
          });
          if (item.name == "我的查询") {
            item.child.push({
              name: "教室VR全景",
              icon: {
                class: "iconfont iconshouye22",
                style: "color:#5E73FF"
              },
              type: "a",
              path:
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf1bb5361ed86c6ec&redirect_uri=https%3A%2F%2Fclassroom.bupt.edu.cn%2Ftsh%2Fwx_login%3Fhrf%3Dhttps%3A%2F%2Fclassroom.bupt.edu.cn%2F%23%2Ftsh%2Fservice%2Findexcumpus&response_type=code&scope=snsapi_b"
            });
          }
        });
      }
      if (!!this.commMenuList) {
            this.commMenuList.forEach(item1 => {
                  this.pathList.forEach(item2 => {
                    if (
                      item1.name.trim() == item2.name.trim() ||
                      (item2.url && item1.url.trim() == item2.url.trim())
                    ) {
                      item1.icon = item2.icon;
                      item1.path = item2.path;
                      item1.imgUrl = item2.imgUrl;
                    }
                  });
                });
      }
      console.log(this.commMenuList);
    },
    // 判断用户类型更改设置
    userConfig() {
      // console.log(this.userType);
      // this.userType = JSON.parse(sessionStorage.getItem("userInfo")).userType;
      this.userType = this.Identity;
      if (this.userType == "2") {
        this.pathList = this.studentList;
      }
      //  if (this.userType == "1")
      else {
        this.pathList = this.teacherList;
      }
      // 个性化的菜单
      this.personMenu();
      // 获取菜单
      this.getMenu();
    }
  },
  created() {
    // 判断用户类型更改设置
    this.userConfig();
    this.schoolCode = sessionStorage.getItem("schoolCode");
    if(this.schoolCode=='10541'||this.schoolCode=='12981'){
      this.heardName = "";
    }
    if(this.schoolCode=='10848'){
      this.menuNub = 4;
    }
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f7f7f7");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  }
};
</script>
<style lang="less" scoped>
.box {
  .box-title {
    white-space: nowrap;
    height: 28px;
    font-family: PingFangSC-SNaNpxibold;
    font-size: 20px;
    color: #272727;
    letter-spacing: 0;
    font-weight: bolder;
    position: absolute;
    top: 24px;
    left: 20px;

    i {
      background: url("../../../../static/img/back.png") no-repeat center;
      width: 30px;
      height: auto;
      background-size: 10px;
    }
  }
  .box-imgS {
    display: inline-flex;
    width: 100%;
    height: 110px;
    background: #8076fc;
    border-radius: 8px;
    margin-bottom: 10px;
    background-image: url("../../../../static/image/headT.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .boximg {
    display: inline-flex;
    width: 100%;
    height: 178px;
    background: #8076fc;
    border-radius: 8px;
    margin-bottom: 10px;
    background-image: url("../../../assets/images/1650521253(1).png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .boximg3 {
    display: inline-flex;
    width: 100%;
    height: 110px;
    background: #8076fc;
    border-radius: 8px;
    margin-bottom: 10px;
    background-image: url("../../../../static/image/headT.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .box-imgT {
    display: inline-flex;
    width: 100%;
    height: 178px;
    background: #8076fc;
    // border-radius: 8px;
    // margin-bottom: 10px;
    background-image: url("../../../../static/images/banner.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .box-img {
    padding-left: 1.5rem;
    font-family: SourceHanSansCN-Medium;
    font-size: 22px;
    color: #ffffff;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.09);
    box-sizing: border-box;
  }
  .box-img > img {
    width: 115px;
    height: 33px;
    padding-top: 12px;
    // line-height: 110px;
    // background-image: url("../../../../static/images/logo.png");
  }

  .box-content,
  .van-collapse-item {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 10px;
    .item-value {
      width: 100%;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      line-height: 18px;
    }
  }
}
</style>
<style lang="less" scoped>

.box {
  .common{
    padding: 9px 0 7px 0px;
    .van-grid-item__content {
      background-color: transparent;
      // justify-content: unset;
      padding: 13px 0;
      // display: flex;
      // position: relative;
      .abb{
        // display: block;
        width: 44px;
        height: 44px;
        background: rgba(43, 103, 225, 0.08);
        border-radius: 22px;
        text-align: center;
        line-height: 57px;
        .iconfont{
          width: 25px;
          height: 25px;
          background: rgba(255, 255, 225,0.01);
        }
      }
      .iconfont {
        // font-size: 42px;
        width: 44px;
        height: 44px;
        // opacity:0.08 ;
        // background: rgb(43, 103, 225);
        background: rgba(43, 103, 225, 0.08);
        border-radius: 22px;
        
      }
      *::before{
        // background-image:linear-gradient(to bottom, #4983Fa, #99BAFF); 
        // color: red;
        // box-shadow: 0 2px 2px 0 #2f69ff;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -100%);
      }
      .item-value {
        width: 100%;
        height: 37px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 8px;
        color: #666;
        letter-spacing: 0;
        text-align: center;
        line-height: 17px;  
        // align-self: flex-start;
      }
    }
      
  }
  .box-content {
    .van-grid-item__content {
      background-color: transparent;
      justify-content: unset;
      padding: 13px 18px;
      .iconfont {
        font-size: 42px;
      }
    }
    .van-collapse-item__title--expanded::after {
      display: none;
    }
    .van-collapse-item__content {
      padding: 0;
    }
    .van-cell__title {
      width: 56px;
      height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
    }
    .van-cell {
      padding: 12px 14px;
    }
    .van-cell,
    .van-collapse-item__content {
      border-radius: 8px !important;
    }
  }
  .my-Dialog {
    h3,
    p {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #7d7e80;
      text-align: center;
      line-height: 20px;
      padding: 10px 0;
    }
    p {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/Home/Home_10013.vue